import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { pains } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-beige/50 py-16 sm:py-24" data-id="element-124" data-mp="30isftdvupbrw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-125" data-mp="2vpzcmug16bhx">
        <SectionHeading eyebrow="¿Te suena familiar?" title="Cada mañana, la misma pregunta: ¿qué le mando hoy?" subtitle="Sos mamá y todos los días tenés que resolver qué mandarle a tu hijo en la vianda escolar. Probablemente te pasa que…" data-id="element-126" data-mp="2vp6cicbkuk8r" />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-127" data-mp="3jeqzd6auq1nb">
          {pains.map((pain, i) => <motion.div key={pain.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.05
        }} className={`flex gap-4 rounded-2xl border border-beige bg-white p-6 shadow-sm ${i === pains.length - 1 && pains.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-128" data-mp="3ehic4rauj7f7" data-mpi={i}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-yellow-soft" data-id="element-129" data-mp="sd0607vqcee1">
                <AlertCircleIcon className="h-6 w-6 text-[#C08A2D]" data-id="element-130" data-mp="x630qjc8ttvt" />
              </div>
              <div data-id="element-131" data-mp="122th77rymrhr">
                <h3 className="font-display text-lg font-bold text-green-deep" data-id="element-132" data-mp="123cwegq871s3">
                  {pain.title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-[#5A6656]" data-id="element-133" data-mp="1c226hnbvrhxs">
                  {pain.body}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}